// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__20H6m","title":"Info_title__2Q_tL","selects":"Info_selects__2dxS0","requiredAsterisk":"Info_requiredAsterisk__Gqm90"};